const styles = {
  container: {
    padding: '20px',
    width: '100%'
  }
}

export default styles
